import { formatText } from 'bernie-l10n';
import * as React from 'react';
import { UitkButtonSize } from 'uitk-react-button';
import { SecondaryButtonTracked } from '../../../utils/click-trackers';
import { useStores } from '../../../utils/hooks';

export interface SortFilterButtonButtonProps {
  pageId?: string;
}

const SortFilterButton: React.FC<SortFilterButtonButtonProps> = ({ pageId }) => {
  const { routeStore } = useStores();
  const href = `${routeStore.pathname}?${routeStore.mergeQueryString(routeStore.search, { pwaDialog: 'filter' })}`;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    event.preventDefault();
    routeStore.updateSearch({ pwaDialog: 'filter' });
  };

  return (
    <SecondaryButtonTracked
      data-testid="sort-filter-dialog-button"
      icon={'tune'}
      text={formatText('lx.search.sortAndFilter')}
      id="sort-and-filter-button"
      type="button"
      isFullWidth={true}
      size={UitkButtonSize.SMALL}
      onClick={handleClick}
      href={href}
      rfrr={pageId ? `LX.${pageId}.filterSort.drawer.open` : ''}
      linkName={'Filter Drawer Clicked'}
    />
  );
};

export const SortFilterDialogButton = React.memo(SortFilterButton);
